module.exports = __webpack_public_path__ + "img/user-selected-white.8aee1341.png";